
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import type { ActivityBtn, CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'
import { Observer } from 'mobx-vue'
import { formatEndTimeCountdown } from '@xt/client/utils/activities/index'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp
  @Prop({ required: true }) readonly btnConfig: ActivityBtn

  timer: ReturnType<typeof setInterval> | null = null
  countDown: string = ''

  get discount() {
    return this.dataSource.originalPrice - this.dataSource.price
  }

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  startTick() {
    if (!this.btnConfig.countdown) return

    const { endTime } = this.btnConfig.countdown

    this.countDown = formatEndTimeCountdown(endTime)

    this.timer = setInterval(() => {
      this.countDown = formatEndTimeCountdown(endTime)
    }, 1000)
  }

  get timeShow() {
    return this.countDown ?? this.btnConfig.time ?? ''
  }

  created(): void {
    this.startTick()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
